import type { ActivityType } from '@movmania/core'

/**
 * Les photos sont servies depuis `public/photos` (voir CREDITS.md) : chemins
 * relatifs à la base, pour que Capacitor les trouve depuis le système de
 * fichiers.
 */
export type PhotoName = ActivityType | 'hero' | 'done' | 'leaves'

export function photo(name: PhotoName): string {
  return `${import.meta.env.BASE_URL}photos/${name}.webp`
}
